import { render, staticRenderFns } from "./ImgComponent.vue?vue&type=template&id=2115721a"
import script from "./ImgComponent.vue?vue&type=script&lang=js"
export * from "./ImgComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports